import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_END_POINT_PLAN, PLAN_END_POINT } from '../../../config';
import { getLocalStorageAuthentication } from '../../../lib/auth';

export const planApi = createApi({
  reducerPath: 'planApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_END_POINT_PLAN}`
  }),
  endpoints: (build) => ({
    findPlansByUserId: build.query({
      query: ({ userId }) => {
        const localAuth = getLocalStorageAuthentication();
        const userIdEncoded = encodeURIComponent(userId);
        const url = `${PLAN_END_POINT}/user/${userIdEncoded}`;
        
        console.log('🌐 [Plans API] Fetching plans from:', `${BASE_END_POINT_PLAN}${url}`);
        console.log('🔑 [Plans API] Using JWT token:', localAuth.token ? 'Present' : 'Missing');
        console.log('👤 [Plans API] User ID:', userId);
        
        return {
          url: url,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localAuth.token}`
          }
        };
      }
    })
  })
});

// Export hooks for usage in functional components
export const {
  useFindPlansByUserIdQuery
} = planApi;

